import React from "react"
import { Box, Text } from "@chakra-ui/react"

/**
 * Renders description that may be plain text (with newlines) or HTML from the rich text editor.
 * Uses whiteSpace pre-line for plain text, dangerouslySetInnerHTML for HTML.
 */
const RichDescription = ({
  content,
  ...rest
}: {
  content: string | undefined
} & React.ComponentProps<typeof Text>) => {
  if (!content) {
    return null
  }

  const isHtml = /<[a-zA-Z][\s\S]*>/.test(content)

  if (isHtml) {
    return (
      <Box
        className="rich-description"
        dangerouslySetInnerHTML={{ __html: content }}
        sx={{
          a: { color: "blue.500" },
          "a:hover": { textDecoration: "underline" },
        }}
        {...rest}
      />
    )
  }

  return <Text whiteSpace="pre-line" {...rest}>{content}</Text>
}

export default RichDescription
